'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _undoRedoSelector = require('../undoRedoSelector');

var _undoRedoTransactionManager = require('../undoRedoTransactionManager');

var _shouldAddUndo = require('./shouldAddUndo');

var _shouldAddUndo2 = _interopRequireDefault(_shouldAddUndo);

var _createUndoAction = require('./createUndoAction');

var _createUndoAction2 = _interopRequireDefault(_createUndoAction);

var _createRedoAction = require('./createRedoAction');

var _createRedoAction2 = _interopRequireDefault(_createRedoAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var addTransactionIdIfNeeded = function addTransactionIdIfNeeded(store) {
    return function (action) {
        if (!action.transactionId) {
            var currentState = store.getState();
            var operation = (0, _undoRedoSelector.getCurrentOperation)(currentState);

            // NOTE: This could potentially use a white-list of action types for each operation
            //      which would then attach the same transaction ID to those actions.
            //      For now, it's left as a 'boolean style string' that catches all actions without
            //      a transaction ID.
            // If we're within a current operation, use its transaction ID
            action.transactionId = operation ? (0, _undoRedoSelector.getMostRecentTransactionId)(currentState) : (0, _undoRedoTransactionManager.getNewTransactionId)();
        }
        return action;
    };
};

// Util


var addUndoRedoAction = function addUndoRedoAction(store) {
    return function (action) {
        var currentState = store.getState();
        action.undoRedoAction = {
            undo: (0, _createUndoAction2.default)(currentState, action),
            redo: (0, _createRedoAction2.default)(currentState, action)
        };
        return action;
    };
};

var enrichAction = function enrichAction(store, action) {
    return (0, _lodash.flow)(addTransactionIdIfNeeded(store), addUndoRedoAction(store))(action);
};

exports.default = function (store) {
    return function (next) {
        return function (action) {
            // check if the action should be added to the stack
            if (!(0, _shouldAddUndo2.default)(store, action)) return next(action);

            var enrichedAction = enrichAction(store, action);
            return next(enrichedAction);
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/middleware/undoRedoMiddleware.js
// module id = 2147
// module chunks = 0